// extracted by mini-css-extract-plugin
export default {"consent_item":"ChallengeTeamCreateAgreement_consent_item__taNSI"};